import type { LocaleCode, ParagraphBlock } from '@fixit/bozp-content';
import { Markdown } from '../markdown';

export function ParagraphBlockView({
  block,
  locale,
}: {
  block: ParagraphBlock;
  locale: LocaleCode;
}) {
  return (
    <div data-block-type="paragraph">
      <Markdown markdown={block.markdown} locale={locale} />
    </div>
  );
}
